/**
 * Toast Component
 * 
 * Simple toast notification component with auto-dismiss.
 */

import React, { useEffect } from 'react';
import './Toast.css';

interface ToastProps {
  message: string;
  duration?: number; // in milliseconds
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, duration = 5000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="toast" role="alert" aria-live="assertive" aria-atomic="true">
      {message}
    </div>
  );
};

export default Toast;
